import { Card, CardContent } from "@/components/ui/card";

export interface JourneyStep {
  phase: string;   // e.g. "Day 1", "Visit 1", "Healing phase"
  title: string;
  desc: string;
}

interface Props {
  eyebrow?: string;
  title?: string;
  steps: JourneyStep[];
}

/**
 * Invisalign-style numbered step journey.
 * Used on every SEO service page so the visual rhythm stays consistent.
 */
const StepsJourney = ({
  eyebrow = "Step by step",
  title = "Your treatment journey at Mutha's Advanced Dental Care",
  steps,
}: Props) => {
  if (!steps || steps.length === 0) return null;
  return (
    <section className="py-14 md:py-20 bg-background">
      <div className="container max-w-5xl">
        <div className="text-center mb-10 md:mb-12">
          <p className="text-xs uppercase tracking-widest text-gold font-semibold mb-2">
            {eyebrow}
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-light text-primary">
            {title}
          </h2>
        </div>
        <div className="space-y-5 md:space-y-6">
          {steps.map((s, i) => (
            <Card
              key={`${s.title}-${i}`}
              className="border-primary/10 hover:shadow-lg hover:-translate-y-0.5 transition-all"
            >
              <CardContent className="p-5 md:p-7 flex flex-col md:flex-row gap-5">
                <div className="shrink-0">
                  <div className="h-16 w-16 rounded-2xl bg-primary text-primary-foreground flex flex-col items-center justify-center">
                    <span className="text-[10px] opacity-80 tracking-wider">STEP</span>
                    <span className="font-heading text-xl font-bold leading-none">
                      {i + 1}
                    </span>
                  </div>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-semibold text-gold mb-1 uppercase tracking-wider">
                    {s.phase}
                  </p>
                  <h3 className="font-heading text-lg md:text-xl font-semibold mb-2 text-primary">
                    {s.title}
                  </h3>
                  <p className="text-sm md:text-[15px] leading-relaxed text-muted-foreground">
                    {s.desc}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StepsJourney;